import axios from "axios";

export default axios.create({
  baseURL: "https://biserna.maticnaknjiga.com:3000",
  headers: {
    "Content-type": "application/json",
  },
});
